export default {
  'EditArtistOverviewTagInput.inputTag': {
    en: 'To add a tag, type a word or phrase and hit enter.',
    fr: 'Pour ajouter une balise, tapez un mot ou une phrase et appuyez sur Entrée.',
  },
};
